export const LOGIN_START = '@login/LOGIN_START'
export const LOGIN_SUCCESS = '@login/LOGIN_SUCCESS'
export const LOGIN_FAILURE = '@login/LOGIN_FAILURE'

export const GET_CSRF_START = '@login/GET_CSRF_START'
export const GET_CSRF_SUCCESS = '@login/GET_CSRF_SUCCESS'
export const GET_CSRF_FAILURE = '@login/GET_CSRF_FAILURE'

export const GET_USERNAME_START = '@login/GET_USERNAME_START'
export const GET_USERNAME_SUCCESS = '@login/GET_USERNAME_SUCCESS'
export const GET_USERNAME_FAILURE = '@login/GET_USERNAME_FAILURE'

export const GET_LOGIN_PAGE_URL_START = '@login/GET_LOGIN_PAGE_URL_START'
export const GET_LOGIN_PAGE_URL_SUCCESS = '@login/GET_LOGIN_PAGE_URL_SUCCESS'
export const GET_LOGIN_PAGE_URL_FAILURE = '@login/GET_LOGIN_PAGE_URL_FAILURE'


// WEBPACK FOOTER //
// ./src/screens/login/actions/types.js